// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".root[data-v-3cde0c69]{border-color:#fff !important}.close-icon[data-v-3cde0c69]{font-size:16px;font-weight:900}.list-item[data-v-3cde0c69]{min-height:56px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.clickable[data-v-3cde0c69]{cursor:pointer}", ""]);
// Exports
module.exports = exports;
